import {Box, Typography, withStyles} from '@material-ui/core';
import {WithStyles} from '@material-ui/core/styles';

import {EnumTeamMemberSlideSize} from './EnumTeamMemberSlideSize';
import {EnumTitlePosition} from './EnumTitlePosition';
import {teamMemberBlockStyles} from './teamMemberBlockStyles';

const TeamMemberBlock: React.FC<ITeamMemberBlockProps> = (props: ITeamMemberBlockProps) => {
	const titleStyles = props.titlePosition === EnumTitlePosition.IN ? props.classes.titleIn : props.classes.title;
	const title = (
		<Typography variant="body1" className={titleStyles}>
			{props.title}
			{props.addComa && ', '}
			{props.jobTitle && (
				<>
					{props.size === EnumTeamMemberSlideSize.EXTRA_LARGE && <br />}
					{props.jobTitle}
				</>
			)}
		</Typography>
	);

	return (
		<Box paddingBottom={EnumTitlePosition.IN ? 2 : 0} className={props.classes.root}>
			<Box className={props.classes.imageBox}>
				{props.titlePosition === EnumTitlePosition.IN && title}
				<img className={props.classes.image} src={props.image} alt={props.title} />
			</Box>
			{props.titlePosition === EnumTitlePosition.BELOW && title}
		</Box>
	);
};

TeamMemberBlock.defaultProps = {
	titlePosition: EnumTitlePosition.BELOW,
	size: EnumTeamMemberSlideSize.MEDIUM,
	addComa: true,
};

interface ITeamMemberBlockProps extends WithStyles {
	title: string;
	jobTitle?: string;
	titlePosition?: EnumTitlePosition;
	image: string;
	size?: EnumTeamMemberSlideSize;
	addComa?: boolean;
}

export default withStyles(teamMemberBlockStyles)(TeamMemberBlock);
